import { render } from "./FAQCategorySelect.vue?vue&type=template&id=682f7fd5"
import script from "./FAQCategorySelect.vue?vue&type=script&lang=js"
export * from "./FAQCategorySelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__